<template>
  <footer class="hidden desktop:flex items-start justify-center min-h-[250px] px-6 pt-[62px] bg-bg">
    <p class="footer-text">© 2025 Dubai Insiders Club - Dubai</p>
  </footer>
</template>

<script setup lang="ts"></script>

<style scoped lang="scss">
.footer-text {
  font-family: 'Satoshi', sans-serif;
  font-weight: 700;
  font-size: 14px;
  line-height: 140%;
  letter-spacing: 0%;
  color: #b6b7b9;
  text-align: center;
}
</style>

